import { isProd } from "../components/helper";
let integration_url;
let delete_api;
let employee_get_api;
let hotelsearch_api;
let locationData_api;

if(isProd()){
    // for prod
    integration_url = 'https://int-api.accorplus.com' 
    delete_api = 'https://api.accorplus.com/v1/hotel/employee/delete/';
    employee_get_api = 'https://api.accorplus.com/v1/hotel/employee';
    hotelsearch_api = "https://api.accorplus.com/v1/hotel-search"; 
    locationData_api = "https://payments-api.accorplus.com/v1/functions/locationdata?country";
} else {
    // for uat and dev
    employee_get_api = "https://api-dev.accorplus.com/v1/hotel/employee"
    delete_api = "https://api-dev.accorplus.com/v1/hotel/employee/delete/";
    integration_url = 'https://api-uat.accorplus.com' 
    hotelsearch_api = "https://api-dev.accorplus.com/v1/hotel-search";
    locationData_api = "https://payments-api-uat.accorplus.com/v1/functions/locationdata?country";
};

export const GLOBALHEADER_MESSAGE = "Global Header Message";

//API URL

export const HOTELSEARCH_CODEURL = 'https://api.accorplus.com/v1/hotel/code/';
// export const HOTELEMPLOYEE_SEARCHURL = 'https://api.accorplus.com/v1/hotel/employee';
export const HOTELEMPLOYEE_SEARCHURL = employee_get_api;
export const HOTELEMPLOYEE_ADDURL = 'https://api.accorplus.com/v1/hotel/employee/add/';
//Currently using `dev`stage for delete employee
export const HOTELEMPLOYEE_DELETEURL = delete_api;
export const HOTELNAME_SEARCHURL = "/data/hotel-search.json";
export const EMPLOYEE_CHECKRESTURL = 'https://api.accorplus.com/v1/employee/status/';//prod

// Updated API URL for hotel search feeds
export const HOTELSEARCH_URL = hotelsearch_api;

export const VENDORAPI = "https://api-uat.accorplus.com/v1/vendor/";

// ADDED API URL for membership price
export const MEMBERSHIP_PRICE = `${integration_url}/v1/netsuite-price-change`
//
export const LOCATION_URL = locationData_api;
export const HEADERAPIVALUE = "hTrmOb88z68c4LOF5huSk698AdlV9mqK4asLDY6o";
export const GLOBALAPIHEADER = {
    headers: {
        'x-api-key': 'hTrmOb88z68c4LOF5huSk698AdlV9mqK4asLDY6o'
      }
};

//PriceLevel for Registration

// export const PRICELEVEL_DISCOUNT    = "hotelAU";
// export const PRICELEVEL_DISCOUNT_NZ = "hotelNZ";
// export const PRICELEVEL_DISCOUNT_TH = "hotelTH";
// export const PRICELEVEL_DISCOUNT_VN = "hotelVN";
// export const PRICELEVEL_DISCOUNT_MY = "hotelMY";
// export const PRICELEVEL_DISCOUNT_ID = "hotelID";
// export const PRICELEVEL_DISCOUNT_SG = "hotelSG";
// export const PRICELEVEL_DISCOUNT_IN = "hotelIN";
// export const PRICELEVEL_DISCOUNT_PH = "hotelPH";

// export const BUSINESS_CATEGORY    = "363";
// export const BUSINESS_CATEGORY_NZ = "423";
// export const BUSINESS_CATEGORY_TH = "438";
// export const BUSINESS_CATEGORY_VN = "500";
// export const BUSINESS_CATEGORY_MY = "453";
// export const BUSINESS_CATEGORY_ID = "452";
// export const BUSINESS_CATEGORY_SG = "463";
// export const BUSINESS_CATEGORY_IN = "467";
// export const BUSINESS_CATEGORY_PH = "484";

export const BUSINESS_CATEGORY    = "363";
export const BUSINESS_CATEGORY_NZ = "423"; // Default BC NZ
export const BUSINESS_CATEGORY_TH = "438"; // Default BC TH
export const BUSINESS_CATEGORY_MY = "470"; // Default BC MY
export const BUSINESS_CATEGORY_ID = "469"; // Default BC ID
export const BUSINESS_CATEGORY_SG = "487"; // Default BC SG
export const BUSINESS_CATEGORY_HK = "758"; // Default BC PH
export const BUSINESS_CATEGORY_IN = "492"; // Default BC IN
export const BUSINESS_CATEGORY_VN = "468"; // Default BC VN
export const BUSINESS_CATEGORY_PH = "503"; // Default BC PH
// Promotions

//Promotions
// export const BUSINESS_CATEGORY    = "1164";
// export const BUSINESS_CATEGORY_NZ = "1165"; // Default BC NZ
// export const BUSINESS_CATEGORY_TH = "1172"; // Default BC TH
// export const BUSINESS_CATEGORY_MY = "1169"; // Default BC MY
// export const BUSINESS_CATEGORY_ID = "1170"; // Default BC ID
// export const BUSINESS_CATEGORY_SG = "1171"; // Default BC SG
// export const BUSINESS_CATEGORY_HK = "1167"; // Default BC PH
// export const BUSINESS_CATEGORY_IN = "1168"; // Default BC IN
// export const BUSINESS_CATEGORY_VN = "1174"; // Default BC VN
// export const BUSINESS_CATEGORY_PH = "1173"; // Default BC PH

export const COUNTRYCODES = [
    'en', 
    'en-AU', 
    'en-CN', 
    'en-FJ', 
    'en-IN', 
    'en-ID', 
    'zh-MO', 
    'en-MY', 
    'en-NZ', 
    'en-PH', 
    'en-SG', 
    'en-TW', 
    'en-TH', 
    'en-VN'
];

export const MAP_COUNTRYCODES = {
    'AU' : 'Australia', 
    'CN' : 'China', 
    'FJ' : 'Fiji', 
    'IN' : 'India', 
    'ID' : 'Indonesia', 
    'MO' : 'Macau', 
    'MY' : 'Malaysia', 
    'NZ' : 'New Zealand', 
    'PH' : 'Philippines', 
    'SG' : 'Singapore', 
    'TW' : 'Taiwan', 
    'TH' : 'Thailand', 
    'VN' : 'Vietnam',
    'KR' : 'South Korea',
    'LA' : 'Lao',
    ''   : 'N/A'
};

export const MAP_COUNTRYLOGO = {
    'AU' : '/images/logo/au.png', 
    'CN' : '/images/logo/cn.png', 
    'FJ' : '/images/logo/fj.png', 
    'IN' : '/images/logo/in.png', 
    'ID' : '/images/logo/id.png', 
    'MO' : '/images/logo/mo.png', 
    'MY' : '/images/logo/my.png', 
    'NZ' : '/images/logo/default.png', 
    'PH' : '/images/logo/ph.png', 
    'SG' : '/images/logo/sg.png', 
    'TW' : '/images/logo/tw.png', 
    'TH' : '/images/logo/th.png', 
    'VN' : '/images/logo/vn.png',
    'KR' : '/images/logo/kr.png',
    'LA' : '/images/logo/default.png',
    ''   : '/images/logo/default.png'
};

export const DOMAINS = ["au","id","vn","th","my"];

